/**
 * BatchInfoCard - Info card for batch details
 */

import { cn } from '@/lib/utils';

interface BatchInfoCardProps {
  label: string;
  value: string;
  variant?: 'orange';
  mono?: boolean;
}

export function BatchInfoCard({ label, value, variant, mono }: BatchInfoCardProps) {
  const bgClass = variant === 'orange'
    ? 'bg-orange-50 dark:bg-orange-950/20'
    : 'bg-neutral-100 dark:bg-neutral-800';
  const labelClass = variant === 'orange'
    ? 'text-orange-600 dark:text-orange-400'
    : 'text-neutral-500 dark:text-neutral-400';
  const valueClass = variant === 'orange'
    ? 'text-orange-700 dark:text-orange-300'
    : 'text-neutral-900 dark:text-neutral-100';

  return (
    <div className={cn('p-4 rounded-lg', bgClass)}>
      <div className={cn('text-xs mb-1', labelClass)}>{label}</div>
      <div className={cn('text-sm font-medium truncate', valueClass, mono && 'font-mono text-xs')}>
        {value}
      </div>
    </div>
  );
}
